import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const designationServices = {
  addNewDesignation,
  updatedDesignation,
  deleteDesignation,
  getDesignationList,
};

// Add New Designation
async function addNewDesignation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewDesignation`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Designation
async function updatedDesignation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedDesignation`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Designation
async function deleteDesignation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteDesignation`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Designation
async function getDesignationList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getDesignationList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getDesignationList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getDesignationList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}